import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ChartsService } from 'src/app/services/charts.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Dealer } from 'src/app/models/dealer.model';
import { DealersService } from 'src/app/services/dealers.service';
import { MatDialog } from '@angular/material/dialog';
import { User } from 'src/app/models/user.model';
import { ChartModel } from 'src/app/models/chart.model';
import { plaintext } from "../../../assets/plaintext";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  userCharts: ChartModel[];

  constructor(private userService: UserService, private chartsService: ChartsService, private router: Router, private route: ActivatedRoute, private dealersService: DealersService,
    public dialog: MatDialog) { }

  dealerId: string;
  dealer: Dealer;
  noCharts = false;
  isLoading = false;
  user: User;
  plaintext = plaintext;

  colsBreakpoint;

  ngOnInit() {
    this.isLoading = true;
    this.user = this.userService.user;
    this.colsBreakpoint = (window.innerWidth <= 700) ? 1 : (window.innerWidth <= 1050) ? 2 : 3;
    if (window.location.href.indexOf('viewas') != -1 && this.userService.user.isAdmin) {
      this.dealerId = this.route.snapshot.paramMap.get('id');
      this.dealersService.observableViewAsId.subscribe(d => {
        if (!d) {
          this.dealersService.getDealersByVendorIds([this.dealerId]).subscribe(res => {
            this.dealer = res[0];
            this.getCharts();
          })
        } else {
          this.dealer = d;
        }
        this.getCharts()
      })
    } else {
      if (this.userService.user.isAdmin) this.router.navigate(['/admin']);

      this.chartsService.getUserCharts().subscribe(data => {
        if (!data || data.length == 0) this.noCharts = true;
        this.userCharts = data;
        this.isLoading = false;
      });
    }

  }

  getCharts() {
    this.chartsService.getChartsForExternal(this.dealer.country, this.dealer.vendorId).subscribe(data => {
      if (!data || data.length == 0) this.noCharts = true;
      this.userCharts = data;
      this.isLoading = false;
    });
  }

  onResize(event) {
    this.colsBreakpoint = (event.target.innerWidth <= 700) ? 1 : (event.target.innerWidth <= 1050) ? 2 : 3;
  }

}
